import React, { useEffect, useState, useRef } from "react";
import CloseForm from "./CloseForm";
import "../../css_files/Master/BoilerPartsDataTable.css";

function BoilerPartsDataTable({ data, loading, close }) {
  return (
    <section className="boiler-parts-data-table">
      <h1>Boiler Parts Mapping Data</h1>
      <section className="table" style={{ width: "70%" }}>
        <section>
          <div>
            <aside style={{ gridTemplateColumns: "repeat(4, 1fr)" }}>
              <blockquote>Sr.No</blockquote>
              <blockquote style={{ gridColumn: "span 3" }}>Parts</blockquote>
            </aside>
          </div>
          <div>
            {loading ? (
              <aside style={{ gridTemplateColumns: "repeat(4, 1fr)" }}>
                <blockquote style={{ gridColumn: "span 4" }}>
                  <center>
                    <i
                      className="fa-solid fa-rotate-right fa-spin"
                      style={{ fontSize: "2.5rem" }}
                    ></i>
                  </center>
                </blockquote>
              </aside>
            ) : data.length > 0 ? (
              data.map((d, i) => (
                <aside style={{ gridTemplateColumns: "repeat(4, 1fr)" }}>
                  <blockquote>{i + 1}</blockquote>
                  <blockquote style={{ gridColumn: "span 3" }}>
                    ({d.partNumber}) {d.name}
                  </blockquote>
                </aside>
              ))
            ) : (
              <aside style={{ gridTemplateColumns: "repeat(4, 1fr)" }}>
                <blockquote style={{ gridColumn: "span 4" }}>
                  No Parts Mapped
                </blockquote>
              </aside>
            )}
          </div>
        </section>
        <CloseForm close={close} />
      </section>
    </section>
  );
}

export default BoilerPartsDataTable;
